module.exports = __webpack_public_path__ + "img/sand-rock-medium-01.f4da82bf.png";